import { getMultiplier } from '@/libs/receiptIssuing/commons'
import state from '@/state'
import { clone } from '@/plugins/utils'

export const remapItems = async (data, paymentMethod, register = undefined) => {

  const multiplier = await getMultiplier()

  const items = data.items.map((item) => {
    let quantity
    if (typeof (item.quantity) === 'string') {
      quantity = parseFloat(item.quantity.replace(',', '.'))
    } else {
      quantity = item.quantity
    }

    var cashRegister = state.getCashRegister()

    if (register) {
      cashRegister = register
    }

    // UKLONJENA LOGIKA: Transakcijski računi (T) sada koriste ISTE cijene kao gotovinski (G) i kartični (K)
    // Ne pozivamo više getWholesaleItem za T jer želimo cijene S PDV-om
    // if (cashRegister.type === 'ALL' && paymentMethod === 'T') {
    //   item = getWholesaleItem(item)
    // }

    const it = {
      name: item.name,
      amt: Math.round(quantity * multiplier),
      id: item.id,
      code: item.code,
      single_item_price: Math.round(item.prices[data.currency].price),
      selling_unit: item.selling_unit,
      price: Math.round(quantity * item.prices[data.currency].price),
      type: item.type,
      pdv: {
        rate: item.prices[data.currency].taxes[0].rate
      },
      pnp: null
    }

    console.log('📊 remapItems - Item mapped:', {
      name: it.name,
      quantity: quantity,
      singleItemPriceInCents: it.single_item_price,
      totalPriceInCents: it.price,
      amountInMilligrams: it.amt,
      pdvRate: it.pdv.rate
    })

    // Add kpdcode if it exists
    if (item.kpdcode) {
      it.kpdcode = item.kpdcode
    }

    // Add tax category and exemption reason for 0% VAT items
    if (item.tax_category) {
      it.tax_category = item.tax_category
    }
    if (item.tax_exemption_reason) {
      it.tax_exemption_reason = item.tax_exemption_reason
    }

    // Add naknade only if they exist and have sellable set to true
    if (item.naknade) {
      const sellableNaknade = {}
      Object.keys(item.naknade).forEach(key => {
        const naknada = item.naknade[key]
        // Only include naknade where sellable is explicitly true
        if (naknada.sellable === true) {
          sellableNaknade[key] = naknada
        }
      })
      // Only add naknade to item if there are sellable ones
      if (Object.keys(sellableNaknade).length > 0) {
        it.naknade = sellableNaknade
      }
    }

    if (item.prices[data.currency].taxes && item.prices[data.currency].taxes.length > 1) {
      item.prices[data.currency].taxes.forEach(tax => {
        if (tax.name === 'PNP') {
          it.pnp = {
            rate: tax.rate
          }
        }
      })
    }

    if (item.choosenProductOrder) {
      it.menu_products = []
      Object.keys(item.choosenProductOrder).forEach(key => {
        if (item.choosenProductOrder[key] && item.choosenProductOrder[key].length > 0) {
          item.choosenProductOrder[key].forEach(product => {
            if (product && product.productItems && product.productItems.length > 0) {
              product.productItems.forEach(pi => {
                if (pi && pi.id !== '') {
                  it.menu_products.push(pi)
                }
              })
            }
          })
        }
      })
    }

    if (item.discounted_price !== undefined && item.discounted_price > 0) {
      it.discounted_price = Math.round(item.discounted_price)
      it.price = Math.round(item.discounted_price * quantity)
    }

    if (item.discount !== undefined) {
      it.discount = item.discount
    }

    return it
  })

  return items
}

export const getWholesaleItem = (item) => {
  var currency = 'EUR'
  const newItem = clone(item)
  var pnpAmt = 0
  if (newItem.prices[currency].taxes.length > 0) {
    newItem.prices[currency].taxes.forEach(tax => {
      if (tax.name === 'PNP') {
        pnpAmt = tax.rate
      }
    })
  }

  var taxes = newItem.prices[currency].taxes[0].rate + pnpAmt

  newItem.prices[currency].price =
    Math.round(parseFloat(newItem.prices[currency].price / (1 + taxes / 10000)), 2)

  return newItem
}
